import { IEquityMovementScheduleFinancialTableData } from './equity-movement-schedule-financial-table-data.interface';

export interface IEquityMovementSchedulePeriodTable {
    /** "Geschäftsjahr 2024" or the spelled-out period range — carried in the data, deliberately not rendered yet. */
    caption: string;
    rows: IEquityMovementScheduleFinancialTableData[];
    colCount: number;
}

export interface IEquityMovementScheduleData {
    tables: IEquityMovementSchedulePeriodTable[];
    textAdditionAboveEms: string | null;
    textAdditionBelowEms: string | null;
}
